import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

import { DEFAULT_LOCALE } from 'shared/consts'

import store from 'shared/store'
import buildClientAPI from 'views/providers/clientAPI'

const SELECTOR_CONTACT_SELLER_MODAL =
  '[data-clientside-hook~="ContactSellerMessageModal"]'
const SELECTOR_CONTACT_SELLER_MODAL_BUTTON =
  '[data-clientside-hook~="openContactSellerMessageModal"]'

export default ({ onLoad } = { onLoad: false }) => {
  /** @type {HTMLButtonElement} buttonModalTrigger */
  const buttonModalTrigger = document.querySelector(
    SELECTOR_CONTACT_SELLER_MODAL_BUTTON
  )

  const mountComponent = async container => {
    const {
      publicConfig: { locale = DEFAULT_LOCALE },
      pageProperties: { orderThreadSubjects = {}, customerId, orderId }
    } = store.getPublicRuntimeConfig()

    // Launch file imports in parallel
    const catalogs = loadCatalogs(locale)
    const hydrationScript = import(
      /* webpackChunkName: "ContactSellerMessageModalContainerWithHydration", webpackPrefetch: true */
      './ContactSellerMessageModalContainerWithHydration'
    )

    const { default: hydrateComponent } = await hydrationScript
    await hydrateComponent({
      locale,
      container,
      catalogs: await catalogs,
      subjectsList: orderThreadSubjects.reasons,
      api: { miraklService: buildClientAPI().miraklService },
      customerId,
      orderId
    })
  }

  const handleClick = event => {
    event.preventDefault()

    buttonModalTrigger.removeEventListener('click', handleClick)
    mountComponent(document.querySelector(SELECTOR_CONTACT_SELLER_MODAL))
  }

  if (onLoad) {
    mountComponent(document.querySelector(SELECTOR_CONTACT_SELLER_MODAL))
  }

  if (buttonModalTrigger) {
    buttonModalTrigger.addEventListener('click', handleClick)
  }
}
